require('./RAPillButton.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

class RAPillButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { changeOption, disabled, value } = this.props;
        if (disabled) return;

        changeOption(value);
    }

    format(value) {
        const { formatter } = this.props;

        return formatter ? formatter(value) : value;
    }

    render() {
        const { disabled, selectedOption, value } = this.props;
        const currentClassname = classnames('ra-pill-button', {
            'ra-pill-button--active': selectedOption === value,
            'ra-pill-button--disabled': disabled,
        });

        return (
            <a className={currentClassname} onClick={this.handleClick}>
                {this.format(value)}
            </a>
        );
    }
}

RAPillButton.propTypes = {
    changeOption: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    formatter: PropTypes.func.isRequired,
    selectedOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

module.exports = RAPillButton;
